export default __webpack_public_path__ + "static/media/propertypanel@2x.56ddca85.png";